module.exports = __webpack_public_path__ + "static/media/dotBG.f27d2803.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ltl-ai/dotBG.gif
// module id = 1293
// module chunks = 3